import { useCallback, useEffect, useState } from 'react';
import { TaskIdType, TaskType } from '../../schemas/task.schemas';
import TasksRepo from '../../utils/repository/tasksRepo/tasksRepo';

function useTask(id: TaskIdType | undefined) {
    const [task, setTask] = useState<TaskType | undefined>();
    const [loading, setLoading] = useState(true);

    const fetchTask = useCallback(() => {
        if (!id) {
            return;
        }

        setLoading(true);
        TasksRepo.getTask(id, (response) => {
            setTask(response.data);
            setLoading(false);
        });
    }, [id]);

    useEffect(() => {
        fetchTask();
    }, [fetchTask]);

    return { task, loading, refetch: fetchTask };
}

export default useTask;
